import AuthSlider from '@/components/auth/AuthSlider';

const Login = () => <AuthSlider initialMode="login" />;

export default Login;
